/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Exclusive_Feature_Tag_TitleInputs */

const en_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Focus Tags`)
};

const ar_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`علامات التركيز المخصصة`)
};

const de_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierte Fokus-Tags`)
};

const es_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiquetas de concentración personalizadas`)
};

const fr_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tags de concentration personnalisés`)
};

const it_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag di concentrazione personalizzati`)
};

const ja_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグのカスタマイズ`)
};

const ko_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 지정 집중 태그`)
};

const pt_br_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcadores de foco personalizados`)
};

const ru_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настройка тегов фокусировки`)
};

const th_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แท็กการโฟกัสที่กำหนดเอง`)
};

const tr_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Özel Odaklanma Etiketleri`)
};

const zh_cn_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义专注标签`)
};

const zh_tw_subscription_exclusive_feature_tag_title = /** @type {(inputs: Subscription_Exclusive_Feature_Tag_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定義專注標籤`)
};

/**
* | output |
* | --- |
* | "Custom Focus Tags" |
*
* @param {Subscription_Exclusive_Feature_Tag_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_exclusive_feature_tag_title = /** @type {((inputs?: Subscription_Exclusive_Feature_Tag_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Exclusive_Feature_Tag_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "ar") return ar_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "de") return de_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "es") return es_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "fr") return fr_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "it") return it_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "ja") return ja_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "ko") return ko_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "pt_br") return pt_br_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "ru") return ru_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "th") return th_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "tr") return tr_subscription_exclusive_feature_tag_title(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_exclusive_feature_tag_title(inputs)
	return zh_tw_subscription_exclusive_feature_tag_title(inputs)
});